import axios from "axios";
import { BASE_URL } from "./apiKeys.js";

const makeAPIRequest = async (method, url, data, headers, params) =>
  new Promise(async (resolve, reject) => {
    const token = await JSON.parse(localStorage.getItem("idToken"));
    const options = {
      ...{
        method,
        url,
        data,
        params,
      },
      ...(token && { headers: { Authorization: token?.jwtToken } }),
    };
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }

    axios(options)
      .then(async (response) => {
        if (response?.status === 200 || response?.status === 201) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(async (error) => {
        // Authentication errors are handled globally by axios interceptor in authUtils.js
        reject(error);
      });
    return null;
  });

// Wrapper function for consistent API interface
export const makeApiCall = async (url, method, data) => {
  try {
    // Ensure URL has the correct base URL
    const fullUrl = url.startsWith('http') ? url : `${BASE_URL}${url.startsWith('/') ? url.slice(1) : url}`;
    const response = await makeAPIRequest(method.toUpperCase(), fullUrl, data);
    
    // The backend returns { success, message, data }, so we need to check the backend response format
    if (response.data && typeof response.data === 'object') {
      // If the backend response has its own success field, use that
      if ('success' in response.data) {
        return {
          success: response.data.success,
          data: response.data.data,
          message: response.data.message,
          status: response.status
        };
      }
      // Otherwise, treat the whole response.data as the data
      return {
        success: true,
        data: response.data,
        status: response.status
      };
    }
    
    // Fallback for non-object responses
    return {
      success: true,
      data: response.data,
      status: response.status
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
      status: error.response?.status
    };
  }
};

export default makeAPIRequest;
